<template>
    <div>        
        <Datatable :dt="dt" class="full-height">
            <template v-slot:menu ="{ item }">
                <ActionMenuItem action="workorder.open" @click="()=>onOpen(item)"></ActionMenuItem>
            </template>

        <template v-slot:item.id_status ="{ item }">
            <span class="cursor-pointer" @click="dlg.open('workorder', item)">            
                <StatusChip :model="item"></StatusChip>
            </span>
        </template>

        <template v-slot:item.priority="{item}">
            <span class="text-error" v-if="item.priority==1">Hoog</span>
            <span v-else-if="item.priority==2">Normaal</span>
            <span v-else-if="item.priority==3">Laag</span>
        </template>

        <template v-slot:item.inv_number="{item}">
            <span v-if="!item.id_invoice"></span>
            <span v-else-if="item.inv_number">{{item.inv_number}}</span>
            <span v-else>Concept</span>
        </template>

            <template v-slot:footer.prepend>
                <v-row dense>
                    <v-col>
                        <v-card flat>
                            <v-card-text>
                                <ActionButton action="workorder.create" sub dusk="btn-add-workorder" :model="model" icon="add" xmain xprimary @click='createWorkorder'>Nieuwe werkbon</ActionButton>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </template>

        </Datatable>

    </div>
</template>



<script setup>
    import useDataTable from '@app/useDataTable'
    import Datatable from '@datatable/Datatable'
    import ActionMenuItem from "@controls/menu/ActionMenuItem.vue";
    import { workorders as api } from '@app/api'
    import dlg from '@app/dlg'
    import ActionButton from '@controls/buttons/ActionButton'
    import PaletteChip from "@controls/widgets/PaletteChip.vue";
    import DateColumn from '@datatable/columns/Date'
    import StatusChip from '@/features/workorders/workorder/controls/StatusChip.vue'
    import {onMounted, onUnmounted} from 'vue'
    import clsDialogUpdateHelper from '@cls/clsDialogUpdateHelper.js';
   // -

    const props = defineProps({
        model: {
            type: [Object]
        },
    });
    function fmtExcelHours(v,V,item) {
        return time.minutes2hourdecimal(v, false)
    }

    var headers = [

        { type: 'cmd'},
        { type: 'flag', flagType: 'workorder_flag'},
        { type: 'note', noteType: 'workorder_note'},
        
        { text: "Nummer"                , value: "number",                  type: 'open', action: 'workorder.open', class: "w-3"},
        { text: "Code"                  , value: "typecode",                class: "w-2"},
        { visible: false, text: "Type"                  , value: "type",                    class: "w-3"},
        { text: "Status"                , value: "id_status",               class: "w-3"   },
        { text: "Naam"                  , value: "title",                   type: 'open', action: 'workorder.open'},
        { visible: false, text: "Doeldatum"              , value: "target_at",               type: 'date'},
        { visible: false, excelType: 'numeric',fmtExcel:fmtExcelHours, text: "Urenschatting"         , value: "estimate", type: 'hhmm'},
        { visible: false, text: "Prioriteit"            , value: "priority",                },
//        { text: "Herhaling"             , value: "recurrence",              fmt: (v, V, item) => fmtRecurrence(item) },
        { visible: false, text: "Relatie"               , value: "rel_name",                },
        { visible: false, text: "Relatie telefoon"      , value: "rel_phone",               type: 'phone', fields: ['rel_phone', 'rel_mobile']},
        { visible: false, text: "Relatie email"         , value: "rel_email",               type:'email'},
        { visible: false, text: "Adres"                 , value: "adr_street",              fmt: (v, V, item) => string.concat(' ', item.adr_street, item.adr_street_number)},
        { visible: false, text: "Postcode"              , value: "adr_zipcode",                 },
        { visible: false, text: "Plaats"                , value: "adr_city",                },
        { visible: false, text: "Contactpersoon"        , value: "firstname",               fmt: (v, V, item) => string.concat(' ', item.prs_firstname, item.prs_infix, item.prs_lastname)},
        { visible: false, text: "Contact email"         , value: "prs_email",               type: 'email'},
        { visible: false, text: "Contact telefoon"      , value: "prs_phone",               type: 'phone', fields: ['prs_phone', 'prs_mobile']},
        { visible: false, isUtc: true, text: "Gewijzigd",                value: "updated_at",    type: 'datetime',   visible: false},
		{ visible: false, text: "Gewijzigd door",           value: "updated_by",                        visible: false},
		{ visible: false, isUtc: true, text: "Aangemaakt",               value: "created_at",    type: 'datetime',   visible: false},
		{ visible: false, text: "Aangemaakt door",          value: "created_by",                        visible: false},
    ]

    var dt = useDataTable("dt_project_workorders", "workorder", api, headers, {
        // hideDefaultFooter: true,
        // noPager: true,
        itemName: {
            prefix: 'De',
            single: 'werkbon',
            plural: 'werkbonnen',
        }, parent: {
            id_relation: props.model.id
        },
        noSaveHandler: true,
        canArchive: false,

    })

    function createWorkorder() {
        dlg.create('workorder', {
            id_relation: props.model.id, 
        })
    }
    async function onOpen(item) {
        var xxx = await dlg.open('workorder', item)        
    }

    async function onRemoveWorkorder(item) {
        console.error('NYI');
    } 


////////////////////////////////////////////////////////////////////////////////////////////////////
//
// Refresh handler. 
// Refresh when a workorder dialog is opened, something triggerd a save event, then the dialog was closed.
//
////////////////////////////////////////////////////////////////////////////////////////////////////
 
    let objRefresher = null;
    onMounted(() => {
        objRefresher = new clsDialogUpdateHelper({
            closeModel: ['workorder'], 
            onCloseRefresh: (modelName, modelData) => {
                if (props.model.isDialogOpen) {
                    dt.refreshLine({id: modelData.id});
                }
            }
        }, true /* debug*/);
    })
    onUnmounted(() => {
      objRefresher && objRefresher.cleanUp();
    })

    
</script>